var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockKeyIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 75,
  height: 75,
  fill: "none",
  viewBox: "0 0 75 75",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.5,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.656 39.156a17.188 17.188 0 1 0 16.622 21.89h3.79l3.126 3.02 3.125-3.004h3.125l3.14 2.982 3.11-2.981 4.687-.022 4.681-4.9-4.725-4.485H35.234a17.24 17.24 0 0 0-16.578-12.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.797 56.344a4.687 4.687 0 1 0 9.375 0 4.687 4.687 0 0 0-9.375 0M70.313 54.703a3.125 3.125 0 0 0 3.124-3.125V26.656a3.125 3.125 0 0 0-3.124-3.11l-34.375-.027a3.125 3.125 0 0 0-3.126 3.125v9.465"
}), /*#__PURE__*/React.createElement("path", {
  d: "m39.081 23.531-.018-7.75a14.063 14.063 0 0 1 28.125-.125l.034 7.875M48.438 37.594a4.688 4.688 0 1 0 9.375 0 4.688 4.688 0 0 0-9.376 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h75v75H0z"
})))));
export { SvgLockKeyIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/lockKeyIcon.svg";